/**
 * 稿子的 `EMO` 表 + `emo()`。用在段标题、跨天两段的行内、加一条的学科 chips。
 *
 * 只是**显示用的装饰**：`homework_items.subject` 存自由文本、不做枚举
 * （学校的课名千奇百怪，见 HomeworkParser::SUBJECTS 上面那段注释）。
 * 认不出来就给 📚，不认为那是错误 —— 「校本课程」「拓展阅读（二）」都会走到那里。
 */
const EMOJI: Record<string, string> = {
  语文: '📕',
  数学: '➗',
  英语: '🔤',
  科学: '🔬',
  道法: '⚖️',
  品德: '⚖️',
  体育: '🏃',
  音乐: '🎵',
  美术: '🎨',
  信息: '💻',
  书法: '🖌️',
  阅读: '📖',
  综合: '📚',
  其它: '📚',
}

export function subjectEmoji(name: string): string {
  if (EMOJI[name]) return EMOJI[name]
  // 「语文（拓展）」这种含子串的也认 —— 稿子的 emo() 就是这么兜的
  for (const key of Object.keys(EMOJI)) {
    if (name.includes(key)) return EMOJI[key]
  }
  return '📚'
}
